import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState, TempFileItem } from './types'
import { Form, Field } from 'react-final-form'
import { useHistory, useParams } from 'react-router-dom'
import { toggle } from 'slidetoggle'
import NumberFormat from 'react-number-format'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import * as typesProfile from '../SignInPage/types'
import { getFormatFromUrl, isDifferentAge } from '../../utils/helpers'

// Styles
import './styles.scss'
import 'react-circular-progressbar/dist/styles.css'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'
import notification from '../../components/Notification'

// Icons
import IconOpen from './images/iconOpen'
import ImageNomination from './images/imageNomination'
import IconAdd from './images/iconAdd'
import IconRemove from './images/iconRemove'
import IconRollUp from './images/iconRollUp'
import IconFile from './images/iconFile'
import IconUpload from './images/iconUpload'
import IconChecked from './images/iconChecked'
import ImageGreenLeaf from './images/imageBackground'
import IconLeaf1 from './images/iconLeaf1'
import IconLeaf2 from './images/iconLeaf2'
import IconLeaf3 from './images/iconLeaf3'
import IconLeaf4 from './images/iconLeaf4'
import IconLeaf5 from './images/iconLeaf5'
import IconLeaf6 from './images/iconLeaf6'
import IconVariantLeaf from './images/iconVariantLeaf'
import IconVariantLeafGray from './images/iconVariantLeafGray'

const allowedAttachFormats = [
  'pdf',
  'doc',
  'docx',
  'txt',
  'jpg',
  'jpeg',
  'png',
  'pptx',
  'ppt',
  'pps',
  'avi',
  'mp4',
  'mkv',
  'mp3',
]

export default () => {
  const [option, setOption] = useState<string>('')
  const [settlements, setSettlements] = useState<string[]>([])
  const [openCheckboxes, setOpenCheckboxes] = useState<boolean>(false)
  const [openNomination, setOpenNomination] = useState<boolean>(false)
  const [openAge, setOpenAge] = useState<boolean>(false)
  const [ageError, setAgeError] = useState<boolean>(false)
  const [title, setTitle] = useState<string>('')
  const [titleError, setTitleError] = useState<boolean>(false)
  const [selectedNomination, setSelectedNomination] = useState<string>('')
  const [selectedAgeCategory, setSelectedAgeCategory] = useState<string>('')
  const [nominationError, setNominationError] = useState<boolean>(false)
  const [uploadedFiles, setUploadedFiles] = useState<TempFileItem[]>([])
  const [initialValues, setInitialValues] = useState<object>({})
  const [heightNomination, setHeightNomination] = useState<number>(314)
  const [actionsError, setActionsError] = useState<boolean>(false)
  const [percentUpload, setPercentUpload] = useState<number>(0)

  const dispatch = useDispatch()
  const isMounted = useRef<boolean>(false)
  const history = useHistory()
  const { id, wid } = useParams<{ id: string; wid: string }>()

  const refCheckboxContent = useRef<HTMLDivElement | null>(null)
  const refUpload = useRef<HTMLInputElement | null>(null)
  const refForm = useRef<any | null>(null)
  const refNominationBlock = useRef<HTMLDivElement | null>(null)

  const { REACT_APP_MAX_MEGABYTE_SIZE_UPLOAD } = process.env

  const {
    contest,
    myWork,
    isFetchingContests,
    isProcessUploadFile,
    isProcessSendWork,
    isFetchingMyWork,
    isProcessRemoveFile,
    lastRemovedFile,
    error,
  } = useSelector(
    (state: { profileContestWork: InitialState }) => state.profileContestWork
  )

  const { profile } = useSelector(
    (state: { profile: typesProfile.InitialState }) => state.profile
  )

  const isAgeAdult =
    profile && profile.external_profile.birthdate
      ? isDifferentAge(profile.external_profile.birthdate, 18)
      : false

  useEffect(() => {
    if (
      error &&
      (!error.includes('Размер файла') || !error.includes('Слишком долгое')) &&
      isMounted.current
    ) {
      notification('error', '', error)
    }
  }, [error])

  useEffect(() => {
    if (refNominationBlock.current) {
      setHeightNomination(refNominationBlock.current?.clientHeight || 0)
    }
  }, [selectedNomination, refNominationBlock.current])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchContest())
    if (wid) {
      dispatch(actions.fetchMyWork(wid))
    }
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (contest && isMounted.current) {
      if (contest.status !== 'started') {
        history.push('/profile/contests')
      }
    }
  }, [contest])

  const getField = (code: string, field: string) => {
    if (contest) {
      const findField = contest.fields.find(item => item.code === code)
      // @ts-ignore
      return findField ? findField[field] : ''
    }
  }

  useEffect(() => {
    if (lastRemovedFile) {
      const filteredFiles = uploadedFiles.filter(file =>
        file.new
          ? file.file_id !== lastRemovedFile
          : file.file.uuid !== lastRemovedFile
      )
      setUploadedFiles([...filteredFiles])
    }
  }, [lastRemovedFile])

  useEffect(() => {
    if (contest && myWork && wid) {
      const territoriesFieldId = getField('territories', 'contest_field_id')
      const territoriesFieldValue = myWork.answers.find(
        answer => answer.contest_field_id === territoriesFieldId
      )?.value

      const answers: { [field: string]: string | boolean } = {}

      const formatValue = (value: string) => {
        if (value === 'true' || value === 'false') return value === 'true'
        return value
      }

      myWork.answers.forEach(
        answer => (answers[answer.contest_field_id] = formatValue(answer.value))
      )

      if (territoriesFieldId && territoriesFieldValue) {
        // @ts-ignore
        answers[territoriesFieldId] = territoriesFieldValue.split(',')
        setSettlements([...territoriesFieldValue.split(',')])
      }

      if (myWork.title) {
        setTitle(myWork.title)
      }

      if (myWork.nomination_id) {
        setSelectedNomination(myWork.nomination_id)
      }

      if (myWork.age_category_id) {
        setSelectedAgeCategory(myWork.age_category_id)
      }

      if (myWork.attachments && myWork.attachments.length) {
        setUploadedFiles(
          [...myWork.attachments].map(file => {
            return { file }
          })
        )
      }

      setInitialValues({ ...answers })
    }
  }, [contest, myWork, wid])

  useEffect(() => {
    if (isMounted.current && refCheckboxContent.current) {
      toggle(refCheckboxContent.current, {
        miliseconds: 500,
        transitionFunction: 'ease-in',
      })
    }
  }, [openCheckboxes])

  const handleChangeOption = (event: ChangeEvent<HTMLInputElement>) => {
    setOption(event.currentTarget.value)
  }

  const addValue = (field: string) => {
    if (!option.length) return
    settlements.push(option)
    setSettlements([...settlements])
    setOption('')
    refForm.current.change(field, settlements.join(','))
  }

  const removeValue = (field: string, index: number) => {
    const removedValue = settlements.filter((_, idx) => idx !== index)
    setSettlements([...removedValue])
    refForm.current.change(field, removedValue.join(','))
  }

  const required = (value: string) => (value ? undefined : 'error')

  const validateDidIncredible = (value: string, allValues: object) => {
    if (
      Object.values(allValues).find(value => value === true) ||
      value?.length
    ) {
      setActionsError(false)
      return undefined
    }
    setActionsError(true)
    return 'error'
  }

  const onChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]
      const format = file ? getFormatFromUrl(file.name) : false
      if (
        ~~(file.size / 1024) / 1024 >
        parseInt(REACT_APP_MAX_MEGABYTE_SIZE_UPLOAD)
      ) {
        notification(
          'error',
          '',
          `Размер файла превышает ${REACT_APP_MAX_MEGABYTE_SIZE_UPLOAD} МБ`
        )
      } else {
        if (format && allowedAttachFormats.includes(format.toLowerCase())) {
          setPercentUpload(0)
          const uploadedFile = (uploadedFile: TempFileItem) => {
            setUploadedFiles([...uploadedFiles, { ...uploadedFile, new: true }])
          }
          dispatch(actions.uploadFile(file, setPercentUpload, uploadedFile))
        } else {
          notification(
            'error',
            'Неверный формат файла',
            `Допустимые форматы: ${allowedAttachFormats.join(', ')}`
          )
        }
      }
      event.target.value = ''
    }
  }

  const removeUploadedFile = (file_id: string) => {
    dispatch(actions.removeFile(file_id))
  }

  const removeWorkFile = (file_id: string) => {
    dispatch(actions.removeFileFromWork(wid, file_id))
  }

  const sendForm = (values: { [field: string]: any }) => {
    if (
      !title.length ||
      !selectedNomination.length ||
      !selectedAgeCategory.length
    ) {
      setTitleError(!title.length)
      setNominationError(!selectedNomination.length)
      setAgeError(!selectedAgeCategory.length)
      return
    }

    const answers = []

    for (const item in values) {
      if (values.hasOwnProperty(item)) {
        answers.push({
          contest_field_id: item,
          value: Array.isArray(values[item])
            ? values[item].join(',')
            : values[item] === 'true' || values[item] === 'false'
            ? values[item] === 'true'
            : values[item],
        })
      }
    }

    const data = {
      contest_id: id,
      nomination_id: selectedNomination,
      age_category_id: selectedAgeCategory,
      description: 'description',
      temporary_files: uploadedFiles
        .filter(file => file?.file_id)
        .map(file => file.file_id),
      title,
      answers,
    }

    if (wid) {
      dispatch(actions.updateWork(wid, data))
    } else {
      dispatch(actions.sendWork(data))
    }
  }

  const validateOtherFields = () => {
    if (
      !title.length ||
      !selectedNomination.length ||
      !selectedAgeCategory.length
    ) {
      setTitleError(!title.length)
      setNominationError(!selectedNomination.length)
      setAgeError(!selectedAgeCategory.length)
    }
  }

  const currentNominationCaption =
    contest &&
    contest.nominations.find(item => item.nomination_id === selectedNomination)

  const currentAgeCategory =
    contest &&
    contest.age_categories.find(
      item => item.age_category_id === selectedAgeCategory
    )

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader />
          {!isMounted.current || isFetchingContests || isFetchingMyWork ? (
            <LoadingPage />
          ) : contest ? (
            <div className={'profile-contests-work'}>
              <div
                className={
                  openNomination || openAge
                    ? 'profile-contests-work__blocker show'
                    : 'profile-contests-work__blocker'
                }
                onClick={() => {
                  setOpenNomination(false)
                  setOpenAge(false)
                }}
              />
              <div className={'profile__leaf'}>
                <ImageGreenLeaf />
              </div>
              <h1 className={'profile-contests-work__title'}>
                Загрузи свою работу!
              </h1>
              <div
                ref={refNominationBlock}
                className={'profile-contests-work__nomination'}
              >
                <div className={'container'}>
                  <div
                    className={
                      openNomination || openAge
                        ? 'profile-contests-work__nomination-background hidden'
                        : 'profile-contests-work__nomination-background'
                    }
                  >
                    <ImageNomination />
                  </div>
                  <div className={'profile-contests-work__nomination-row'}>
                    <div className={'left'}>
                      {currentNominationCaption?.description ? (
                        <>
                          <div className={'left__title'}>
                            Описание номинации
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                currentNominationCaption.description.replace(
                                  /\n/g,
                                  '<br />'
                                ),
                            }}
                            className={'left__description'}
                          />
                        </>
                      ) : null}
                    </div>
                    <div className={'right'}>
                      <div className={'right__field'}>
                        <span>
                          Укажи название <br />
                          твоей работы
                        </span>
                        <textarea
                          className={'edit-title'}
                          maxLength={100}
                          value={title}
                          onChange={event => {
                            setTitle(event.target.value)
                            setTitleError(false)
                          }}
                          style={titleError ? { borderColor: 'red' } : {}}
                        />
                      </div>
                      <div
                        className={
                          openNomination
                            ? 'right__nomination opened'
                            : 'right__nomination'
                        }
                      >
                        <button
                          onClick={() => {
                            if (!wid) {
                              setOpenNomination(!openNomination)
                              setOpenAge(false)
                              setNominationError(false)
                            }
                          }}
                          className={
                            wid
                              ? 'right__nomination-button filled'
                              : 'right__nomination-button'
                          }
                          style={
                            nominationError ? { border: '1px solid red' } : {}
                          }
                        >
                          <div className={'selected'}>
                            {selectedNomination ? (
                              <>
                                <IconVariantLeaf />
                                <p
                                  className={
                                    currentNominationCaption?.caption
                                      ? currentNominationCaption.caption
                                          .length > 17
                                        ? 'long'
                                        : ''
                                      : ''
                                  }
                                >
                                  {currentNominationCaption?.caption}
                                </p>
                              </>
                            ) : (
                              'Выбор номинации'
                            )}
                          </div>
                          {wid ? null : <IconOpen />}
                        </button>
                        <div className={'right__nomination-options'}>
                          {contest.nominations.map(item => (
                            <div
                              key={item.nomination_id}
                              className={'variant'}
                              onClick={() => {
                                setSelectedNomination(item.nomination_id)
                                setOpenNomination(false)
                              }}
                            >
                              {item.nomination_id === selectedNomination ? (
                                <IconVariantLeaf className={'variant__leaf'} />
                              ) : (
                                <IconVariantLeafGray
                                  className={'variant__leaf'}
                                />
                              )}
                              {item.caption}
                            </div>
                          ))}
                        </div>
                      </div>
                      <div
                        className={
                          openAge
                            ? 'right__nomination opened'
                            : 'right__nomination'
                        }
                        style={{
                          zIndex: openNomination ? -4 : 1,
                          marginTop: 18,
                        }}
                      >
                        <button
                          onClick={() => {
                            if (!wid) {
                              setOpenAge(!openAge)
                              setOpenNomination(false)
                              setAgeError(false)
                            }
                          }}
                          className={
                            wid
                              ? 'right__nomination-button filled'
                              : 'right__nomination-button'
                          }
                          style={ageError ? { border: '1px solid red' } : {}}
                        >
                          <div className={'selected'}>
                            {selectedAgeCategory ? (
                              <>
                                <IconVariantLeaf />
                                <p
                                  className={
                                    currentAgeCategory?.caption
                                      ? currentAgeCategory.caption.length > 17
                                        ? 'long'
                                        : ''
                                      : ''
                                  }
                                >
                                  {currentAgeCategory?.caption}
                                </p>
                              </>
                            ) : (
                              'Выбор возрастной группы'
                            )}
                          </div>
                          {wid ? null : <IconOpen />}
                        </button>
                        <div className={'right__nomination-options'}>
                          {contest.age_categories.map(item => (
                            <div
                              key={item.age_category_id}
                              className={'variant'}
                              onClick={() => {
                                setSelectedAgeCategory(item.age_category_id)
                                setOpenAge(false)
                              }}
                            >
                              {item.age_category_id === selectedAgeCategory ? (
                                <IconVariantLeaf className={'variant__leaf'} />
                              ) : (
                                <IconVariantLeafGray
                                  className={'variant__leaf'}
                                />
                              )}
                              {item.caption}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{ height: heightNomination }}
                className={'profile-contests-work__empty'}
              />
              <div className={'profile-contests-work__title-worksheet'}>
                Анкета участника конкурса
              </div>
              <div className={'profile-contests-work__form'}>
                <Form
                  onSubmit={sendForm}
                  initialValues={initialValues}
                  render={({ handleSubmit, form, submitFailed }) => {
                    refForm.current = form
                    return (
                      <form onSubmit={handleSubmit}>
                        <div className={'field__textarea big'}>
                          <div className={'leaf'}>
                            <IconLeaf1 />
                          </div>
                          <div className={'field__info'}>
                            <div className={'field__info-title'}>
                              {getField('essence', 'caption')}
                            </div>
                            <div className={'field__info-description'}>
                              {getField('essence', 'description')}
                            </div>
                          </div>
                          <Field
                            component={'textarea'}
                            name={getField('essence', 'contest_field_id')}
                            validate={
                              getField('essence', 'required')
                                ? required
                                : undefined
                            }
                          >
                            {({ input, meta }) => (
                              <textarea
                                {...input}
                                maxLength={getField('essence', 'max_length')}
                                style={
                                  meta.error === 'error' && meta.touched
                                    ? { border: '1px solid red' }
                                    : {}
                                }
                              />
                            )}
                          </Field>
                        </div>
                        <div className={'field__row'}>
                          <div className={'field__row-item'}>
                            <div className={'field__input'}>
                              <div className={'leaf'}>
                                <IconLeaf2 />
                              </div>
                              <div className={'field__info'}>
                                <div className={'field__info-title'}>
                                  {getField('number_of_persons', 'caption')}
                                </div>
                              </div>
                              <Field
                                component={'input'}
                                type={'number'}
                                name={getField(
                                  'number_of_persons',
                                  'contest_field_id'
                                )}
                                maxLength={getField(
                                  'number_of_persons',
                                  'max_length'
                                )}
                                validate={
                                  getField('number_of_persons', 'required')
                                    ? required
                                    : undefined
                                }
                              >
                                {({ input, meta }) => (
                                  <NumberFormat
                                    value={input.value}
                                    format={'####'}
                                    min={0}
                                    style={
                                      meta.error === 'error' && meta.touched
                                        ? { border: '1px solid red' }
                                        : {}
                                    }
                                    onChange={input.onChange}
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className={'field__row-item'}>
                            <div className={'field__input'}>
                              <div className={'leaf'}>
                                <IconLeaf3 />
                              </div>
                              <div className={'field__info'}>
                                <div className={'field__info-title'}>
                                  {getField('first_mention', 'caption')}
                                </div>
                                <div className={'field__info-description'}>
                                  {getField('first_mention', 'description')}
                                </div>
                              </div>
                              <Field
                                component={'input'}
                                type={'number'}
                                name={getField(
                                  'first_mention',
                                  'contest_field_id'
                                )}
                                maxLength={getField(
                                  'first_mention',
                                  'max_length'
                                )}
                                validate={
                                  getField('first_mention', 'required')
                                    ? required
                                    : undefined
                                }
                              >
                                {({ input, meta }) => (
                                  <NumberFormat
                                    value={input.value}
                                    format={'####'}
                                    min={0}
                                    placeholder={'● ● ● ●'}
                                    style={
                                      meta.error === 'error' && meta.touched
                                        ? { border: '1px solid red' }
                                        : {}
                                    }
                                    onChange={input.onChange}
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div className={'field__textarea'}>
                          <div className={'leaf'}>
                            <IconLeaf4 />
                          </div>
                          <div className={'field__info'}>
                            <div className={'field__info-title'}>
                              {getField('last_names', 'caption')}
                            </div>
                          </div>
                          <Field
                            component={'textarea'}
                            name={getField('last_names', 'contest_field_id')}
                            validate={
                              getField('last_names', 'required')
                                ? required
                                : undefined
                            }
                          >
                            {({ input, meta }) => (
                              <textarea
                                {...input}
                                maxLength={getField('last_names', 'max_length')}
                                style={
                                  meta.error === 'error' && meta.touched
                                    ? { border: '1px solid red' }
                                    : {}
                                }
                              />
                            )}
                          </Field>
                        </div>
                        <div className={'field__selector'}>
                          <div className={'leaf'}>
                            <IconLeaf5 />
                          </div>
                          <div className={'field__selector-row'}>
                            <div className={'field__selector-row-item'}>
                              <div className={'field__info'}>
                                <div className={'field__info-title'}>
                                  {getField('territories', 'caption')}
                                </div>
                              </div>
                              <div className={'field__info-description'}>
                                {getField('territories', 'description')}
                              </div>
                            </div>
                            <div className={'field__selector-row-item'}>
                              <div className={'field__values'}>
                                <Field
                                  component={'input'}
                                  name={getField(
                                    'territories',
                                    'contest_field_id'
                                  )}
                                  validate={
                                    getField('territories', 'required')
                                      ? required
                                      : undefined
                                  }
                                >
                                  {({ meta }) => (
                                    <input
                                      className={'field__values-input'}
                                      type={'text'}
                                      value={option}
                                      onChange={handleChangeOption}
                                      style={
                                        meta.error === 'error' && meta.touched
                                          ? { border: '1px solid red' }
                                          : {}
                                      }
                                    />
                                  )}
                                </Field>
                              </div>
                              <div className={'field__values-row'}>
                                {settlements.map((i, idx) => (
                                  <div
                                    key={`values_${idx}`}
                                    className={'field__values-item'}
                                  >
                                    <IconRemove
                                      style={{ margin: '-3px 21px 0 5px' }}
                                      onClick={() =>
                                        removeValue(
                                          getField(
                                            'territories',
                                            'contest_field_id'
                                          ),
                                          idx
                                        )
                                      }
                                    />
                                    {i}
                                  </div>
                                ))}
                                <button
                                  type={'button'}
                                  onClick={() =>
                                    addValue(
                                      getField(
                                        'territories',
                                        'contest_field_id'
                                      )
                                    )
                                  }
                                  className={'field__values-button'}
                                >
                                  <IconAdd style={{ marginRight: 16 }} />
                                  Добавить
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={'field__checkboxes'}>
                          <div className={'leaf'}>
                            <IconLeaf6 />
                          </div>
                          <div className={'field__checkboxes-header'}>
                            <span>
                              Работая над данным исследованием, ты совершил
                              следующие действия:
                            </span>
                            <button
                              type={'button'}
                              className={openCheckboxes ? 'opened' : ''}
                              onClick={() => setOpenCheckboxes(!openCheckboxes)}
                              style={
                                actionsError && submitFailed
                                  ? {
                                      border: '1px solid red',
                                    }
                                  : {}
                              }
                            >
                              <IconRollUp />
                              Развернуть
                            </button>
                          </div>
                          <div
                            ref={refCheckboxContent}
                            className={'field__checkboxes-content'}
                          >
                            <div className={'field__checkboxes-row'}>
                              <div className={'left'}>
                                {contest.fields
                                  .filter(item => item.type === 'boolean')
                                  .filter((_, idx) => idx % 2 === 0)
                                  .map(item => (
                                    <div
                                      key={item.code}
                                      className={'field__checkboxes-item'}
                                    >
                                      <label
                                        htmlFor={`check-left-${item.code}`}
                                      >
                                        <Field
                                          name={getField(
                                            item.code,
                                            'contest_field_id'
                                          )}
                                          id={`check-left-${item.code}`}
                                          type={'checkbox'}
                                          component="input"
                                        />
                                        <div className={'checkbox'}>
                                          <div className={'checked'}>
                                            <IconChecked />
                                          </div>
                                        </div>
                                        {item.caption}
                                      </label>
                                    </div>
                                  ))}
                              </div>
                              <div className={'right'}>
                                {contest.fields
                                  .filter(item => item.type === 'boolean')
                                  .filter((_, idx) => idx % 2 !== 0)
                                  .map(item => (
                                    <div
                                      key={item.code}
                                      className={'field__checkboxes-item'}
                                    >
                                      <label
                                        htmlFor={`check-right-${item.code}`}
                                      >
                                        <Field
                                          name={getField(
                                            item.code,
                                            'contest_field_id'
                                          )}
                                          id={`check-right-${item.code}`}
                                          type={'checkbox'}
                                          component="input"
                                        />
                                        <div className={'checkbox'}>
                                          <div className={'checked'}>
                                            <IconChecked />
                                          </div>
                                        </div>
                                        {item.caption}
                                      </label>
                                    </div>
                                  ))}
                              </div>
                            </div>
                            <div className={'field__checkboxes-bottom'}>
                              <label>
                                {getField('did_incredible', 'caption')}
                                <br />
                                {getField('did_incredible', 'description')}
                              </label>
                              <Field
                                component={'textarea'}
                                name={getField(
                                  'did_incredible',
                                  'contest_field_id'
                                )}
                                validate={validateDidIncredible}
                              >
                                {({ input, meta }) => (
                                  <textarea
                                    {...input}
                                    className={'textarea'}
                                    maxLength={getField(
                                      'did_incredible',
                                      'max_length'
                                    )}
                                    style={
                                      meta.error === 'error' && meta.touched
                                        ? { border: '1px solid red' }
                                        : {}
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div className={'nav'}>
                          <div className={'nav__left'}>
                            <div className={'files'}>
                              {isProcessUploadFile ? (
                                <div className={'process-upload'}>
                                  <div className={'process-upload__circular'}>
                                    <CircularProgressbar
                                      value={percentUpload}
                                      text={`${percentUpload}%`}
                                      styles={buildStyles({
                                        pathColor: 'rgba(244, 186, 39, 1)',
                                        textColor: '#000',
                                        trailColor: 'rgba(244, 186, 39, 0.15)',
                                        backgroundColor: '#FFF',
                                        textSize: '22px',
                                      })}
                                    />
                                  </div>
                                  <div className={'process-upload__text'}>
                                    Отправка файла
                                  </div>
                                </div>
                              ) : null}
                              {[...uploadedFiles].reverse().map(file => (
                                <div
                                  key={file.file.uuid}
                                  className={'files__item'}
                                >
                                  <a
                                    href={file.file.url}
                                    target={'_blank'}
                                    rel="noreferrer"
                                  >
                                    <IconFile />
                                  </a>
                                  <div className={'files__item-info'}>
                                    <div className={'name'}>
                                      {file.file.name}
                                    </div>
                                    <div
                                      className={'remove'}
                                      onClick={() =>
                                        file.file_id
                                          ? removeUploadedFile(file.file_id)
                                          : removeWorkFile(file.file.uuid)
                                      }
                                    >
                                      Удалить{' '}
                                      <IconRemove style={{ marginLeft: 9 }} />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <button
                              type={'button'}
                              className={'files__upload'}
                              onClick={() => {
                                if (refUpload.current)
                                  refUpload.current?.click()
                              }}
                              disabled={
                                isProcessUploadFile || isProcessRemoveFile
                              }
                            >
                              <input
                                type={'file'}
                                id={'upload'}
                                className={'files__upload-input'}
                                ref={refUpload}
                                onChange={onChangeFile}
                                accept={
                                  '.doc, .docx, .pdf, .txt, .jpeg, .jpg, .png, .ppt, .pptx, video/mp4, .avi, .mkv, .mp3'
                                }
                              />
                              <IconUpload />
                              {uploadedFiles.length ? (
                                <span>
                                  Прикрепить
                                  <br />
                                  еще один файл
                                </span>
                              ) : (
                                <span>Прикрепить файл</span>
                              )}
                            </button>
                          </div>
                          <div className={'nav__right'}>
                            <button
                              type={'submit'}
                              className={'nav__right-button'}
                              onClick={validateOtherFields}
                              disabled={
                                isProcessSendWork ||
                                isProcessUploadFile ||
                                isProcessRemoveFile ||
                                isAgeAdult
                              }
                            >
                              {isProcessSendWork ? (
                                <Loading
                                  color={'#FFF'}
                                  style={{ margin: 0 }}
                                  width={50}
                                  height={50}
                                />
                              ) : (
                                `${wid ? 'Сохранить' : 'Загрузить'} работу`
                              )}
                            </button>
                            {titleError ||
                            nominationError ||
                            submitFailed ||
                            ageError ? (
                              <span className={'nav__right-error'}>
                                Не все поля заполнены
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </form>
                    )
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <Footer />
    </>
  )
}
